import { render } from "./PanelHeader.vue?vue&type=template&id=fad41468&scoped=true"
import script from "./PanelHeader.vue?vue&type=script&lang=js"
export * from "./PanelHeader.vue?vue&type=script&lang=js"

import "./PanelHeader.vue?vue&type=style&index=0&id=fad41468&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fad41468"],['__file',"src/scripts/common/sideBars/components/PanelHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fad41468"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fad41468', __exports__)) {
    api.reload('fad41468', __exports__)
  }
  
  module.hot.accept("./PanelHeader.vue?vue&type=template&id=fad41468&scoped=true", () => {
    api.rerender('fad41468', render)
  })

}


export default __exports__